export const MAX_POLL_DURATION_MS = 10 * 60 * 1_000;
const LS_KEY = "rivmo_pending_exports";

export interface PendingExportEntry {
  jobId: string;
  statusUrl: string;
  layerName?: string;
  format?: string;
  startedAt: number;
}

export function getPendingExports(): PendingExportEntry[] {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw) as PendingExportEntry[];
    const cutoff = Date.now() - MAX_POLL_DURATION_MS;
    return arr.filter((entry) => entry.startedAt > cutoff);
  } catch {
    return [];
  }
}

export function savePendingExport(entry: PendingExportEntry) {
  try {
    const existing = getPendingExports();
    const updated = existing.filter((item) => item.jobId !== entry.jobId);
    updated.push(entry);
    localStorage.setItem(LS_KEY, JSON.stringify(updated));
  } catch {}
}

export function removePendingExport(jobId: string) {
  try {
    const existing = getPendingExports();
    localStorage.setItem(
      LS_KEY,
      JSON.stringify(existing.filter((entry) => entry.jobId !== jobId))
    );
  } catch {}
}
